"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getAuthorizedApplicationsService {
        MyHomeAccount {
            user {
                authorizedApplications {
                    audience
                    clientId
                    isRetail
                    lotNumber
                    name
                    userId
                }
            }
        }
    }
`;exports.getAuthorizedApplications=e;
//# sourceMappingURL=queries.js.map
